import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LANGUAGE_LOCAL_STORAGE_KEY } from '@core/services/language.service';
import { environment as ENV } from '@env/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { FeaturesService } from '../services';
import { AccessTokenService } from '../services/access-token.service';

const ourRoute = (req) => ENV.auth_ic_our_routes.filter((el) => req.url.includes(el))?.length;
const skipRoute = (req) => ENV.auth_ic_skip_routes.filter((el) => req.url.includes(el))?.length;

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  private token_srv = inject(AccessTokenService);
  private featuresService = inject(FeaturesService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!ourRoute(req) || skipRoute(req)) {
      return next.handle(req);
    }

    // Force logout if no refresh token present
    if (!this.token_srv.refreshable()) {
      console.debug(`⚠️ AccessTokenInterceptor: Force logout!`);
      this.token_srv.force_logout();
      return next.handle(req);
    }

    // Set Auth
    req = this.token_srv.getReqWithAuth(req);
    console.debug(`AccessTokenInterceptor: refresh...`);

    // Some stuff
    const languageCode = localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY);
    const currency = this.featuresService.portalCurrency;
    if (currency) {
      req = req.clone({ setHeaders: { ['x-portal-currency']: currency.toString() } });
    }

    if (languageCode) {
      req = req.clone({ setHeaders: { ['x-portal-language']: languageCode } });
    }

    // Vai!
    return next.handle(req).pipe(
      catchError((err) => {
        console.warn(`AccessTokenInterceptor: refresh error: `, err);
        if (err.status === 401) {
          return this.token_srv.process_request(req, next);
        }
        return throwError(err);
      }),
    );
  }
}
